import SearchFieldSelect from "../../../components/textfield/searchFieldSelect";
import HeaderBar from "../../../components/header/headerBar";
import Select from "../../../components/select/select";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { mdiPrinter, mdiPencilCircle, mdiDelete } from "@mdi/js";
import { TableColumn, Table } from "../../../components/table";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../../../assets/styles/admin/stock.scss";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const RequestStock = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [state, setState] = useState<any>({
    listdata: [],
  });
  const option = [
    { value: "", name: "ค้นหาจาก " },
    { value: "1", name: "ALL" },
    { value: "2", name: "ALL" },
    { value: "3", name: "ALL" },
  ];

  const onChangeOtherd = (index: string) => {
    console.log("index xxx => ", index);
  };

  const columns = [
    {
      title: "",
    },
    {
      title: "",
    },
    {
      title: "เลขที่คำขอ",
    },
    {
      title: "จากสาขา",
    },
    {
      title: "ไปสาขา",
    },
    {
      title: "ประเภทคำขอ",
    },
    {
      title: "วันที่",
      align: "center",
    },
    {
      title: "สถานะ",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  const data = [
    {
      _id: 1,
      codereq: "R9-REQ64040087",
      listitem: "สำนักงานใหญ่",
      unit: "พระราม 9",
      unitprice: "เบิกสาขา/เร่งด่วน",
      usedamount: "25-08-2564",
      status: "รออนุมัติ",
    },
    {
      _id: 2,
      codereq: "R9-REQ64040087",
      listitem: "สำนักงานใหญ่",
      unit: "พระราม 9",
      unitprice: "เบิกสาขา/เร่งด่วน",
      usedamount: "25-08-2564",
      status: "อนุมัติ",
    },
    {
      _id: 3,
      codereq: "R9-REQ64040087",
      listitem: "สำนักงานใหญ่",
      unit: "พระราม 9",
      unitprice: "เบิกสาขา/เร่งด่วน",
      usedamount: "25-08-2564",
      status: "ยกเลิก",
    },
  ];

  const getAPIs = () => {
    setState({ ...state, listdata: data });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <>
      <div>
        <HeaderBar title="REQUEST" />

        <div style={{ padding: "10px 40px" }}>
          <SearchFieldSelect
            placeholder=""
            color="#FFFFFF"
            option={option}
            onChangeOtherd={onChangeOtherd}
          />
          <div className="row selectWapper">
            <div className="sCoin">
              <div className="text-select-wapper">
                <Select title="CATEGORY :" option={option} />
              </div>
              &nbsp;
              <div
                className="text-select-wapper"
                style={{ marginTop: "-10px" }}
              >
                <MainButton
                  title="Print"
                  to={`#`}
                  width="90px"
                  background="#FFF"
                  color="#000000"
                >
                  <IconMdi path={mdiPrinter} size="20" color="#86CFC6" />
                </MainButton>
              </div>
            </div>
            <div className="btnCoin">
              <MainButton
                title="สร้างรายการเบิก"
                to={`/setting/stock/requestStock/stockRequest`}
              ></MainButton>
            </div>
          </div>
          <div style={{ padding: "10px 0px" }}>
            <Table header={columns}>
              {state.listdata.map((item: any, index: number) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="2%" align="center">
                    <input
                      type="checkbox"
                      name="ins_checkbox"
                      id={`${item._id}`}
                      className="form-check-input"
                    />
                  </TableColumn>
                  <TableColumn width="5%">{item.codereq}</TableColumn>
                  <TableColumn width="5%">{item.listitem}</TableColumn>
                  <TableColumn width="5%">{item.unit}</TableColumn>
                  <TableColumn width="3%">{item.unitprice}</TableColumn>
                  <TableColumn width="3%" align="center">
                    {item.usedamount}
                  </TableColumn>
                  <TableColumn width="2%" align="center">
                    <div
                      className={`${
                        item.status === "รออนุมัติ"
                          ? "pending-status"
                          : item.status === "อนุมัติ"
                          ? "success-status"
                          : "close-status"
                      }`}
                    >
                      {item.status}
                    </div>
                  </TableColumn>
                  <TableColumn width="2%" align="center">
                    <div
                      onClick={() => {
                        history.push(
                          `/setting/stock/requestStock/${item._id}/stockRequestWithDraw`
                        );
                      }}
                    >
                      <IconMdi
                        path={mdiPencilCircle}
                        size="24"
                        color="#5BAEA9"
                      />
                    </div>
                  </TableColumn>
                  <TableColumn
                    width="2%"
                    align="center"
                    onClick={() => {
                      showDeleteConfirm(item._id, item.listitem);
                    }}
                  >
                    <div>
                      <IconMdi
                        path={mdiDelete}
                        size="24"
                        color="#FF6760"
                      ></IconMdi>
                    </div>
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
export default RequestStock;
